import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { EmployeesService } from '../../../../services/employees';

@Component({
  selector: 'app-employeepagemobile',
  templateUrl: './employeepagemobile.component.html',
  styleUrl: './employeepagemobile.component.scss'
})
export class EmployeepagemobileComponent implements OnInit {
  allData: any[] = [];

  totalItems = 0;
  currentPage = 1;
  lastPage = 1;

  isAr: boolean = localStorage.getItem('language') === 'ar';

  contentReady = true;
  loadingMore = false;
  noData = false;
  searched = false;

  isMobile = false;
  accountType!: string;
  isAdmin = false;
  isSubAdmin = false;

  hasMorePages = true;

  constructor(
    private router: Router,
    private _employessService: EmployeesService,
    private _userService: UserService,
    private deviceService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.getAccountType();
  }

  getAccountType(): void {
    this.contentReady = true;

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';

        if (this.isAdmin || this.isSubAdmin) {
          this.resetAndLoadEmployees();
          return;
        }

        this.allData = [];
        this.noData = true;
        this.contentReady = false;
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  resetAndLoadEmployees(): void {
    this.allData = [];
    this.currentPage = 1;
    this.lastPage = 1;
    this.totalItems = 0;
    this.hasMorePages = true;
    this.noData = false;

    this.getAllEmployees(1, true);
  }

  getAllEmployees(page: number, firstLoad: boolean = false): void {
    if (firstLoad) {
      this.contentReady = true;
    } else {
      this.loadingMore = true;
    }

    this.searched = false;

    this._employessService.getAllEmployees(page).subscribe({
      next: (data) => {
        const newData = data?.data || [];

        this.totalItems = data?.total || 0;
        this.lastPage = data?.last_page || 1;
        this.currentPage = data?.current_page || page;

        if (firstLoad) {
          this.allData = newData;
        } else {
          this.allData = [...this.allData, ...newData];
        }

        this.noData = this.allData.length === 0;
        this.hasMorePages = this.currentPage < this.lastPage;

        this.contentReady = false;
        this.loadingMore = false;
      },
      error: (error) => {
        console.error(error);

        if (firstLoad) {
          this.allData = [];
          this.noData = true;
          this.contentReady = false;
        }

        this.loadingMore = false;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.contentReady || this.loadingMore || !this.hasMorePages || this.noData) {
      return;
    }

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached = scrollPosition + windowHeight >= pageHeight - 220;

    if (bottomReached) {
      this.loadMoreEmployees();
    }
  }

  loadMoreEmployees(): void {
    if (this.loadingMore || !this.hasMorePages) {
      return;
    }

    const nextPage = this.currentPage + 1;
    this.getAllEmployees(nextPage, false);
  }

  showEmployee(itemobj: any): void {
    if(this.isMobile) {
  this.router.navigate(['/employee.mobile'], { queryParams: itemobj });
  
    }
    else{
    this.router.navigate(['/employee'], { queryParams: itemobj });
  }
  }

  edit(itemobj: any): void {
    if (this.isSubAdmin) {
      return;
    }

    this.router.navigate(['/addemployee'], { queryParams: itemobj });
  }

  deleteitem(id: string): void {
    if (this.isSubAdmin) {
      return;
    }

    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no'
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;

        this._employessService.deleteEmployee(id).subscribe({
          next: () => {
            this.resetAndLoadEmployees();
          },
          error: (err) => {
            console.log(err);
            this.contentReady = false;
          }
        });
      }
    });
  }

  trackByEmployeeId(index: number, item: any): any {
    return item?.id || index;
  }

  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);

    return `${day}-${month}-${year}`;
  }
}
